<template>
  <div>
    <div class="panel text-left">
      <div :class="['loading-area', commissionsSaving ? 'loading' : '']">
        <div
          :class="['loading-area__content', commissionsSaving ? 'loading' : '']"
        >
          <div class="panel__header">
            <!--            <p>{{this.commission}}</p>-->
            <h3 class="panel__title">Commission Configuration</h3>
          </div>

          <div class="panel__content">
            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Tracking Type
                    <span
                      data-tooltip
                      tabindex="1"
                      title="If Vendor Name is chosen commissions will be awarded by the vendor name on a product. If Product Tag is chosen then commissions will be awarded by a tag look up starting with vendor_">
                      <i class="fas fa-question-circle"></i
                      ></span>
                  </label>
                </div>

                <div class="cell auto">
                  <label
                    :class="[
                      'radio-choice',
                      settings && settings.tracking_type === 'Vendor Name'
                        ? 'active'
                        : '',
                    ]"
                    @click="chooseTracking('Vendor Name')"
                  >Vendor Name
                    <input
                      id="tracking-vendor-name"
                      class="hidden"
                      type="radio"
                      name="tracking"
                      value="vendor-name"
                    />
                  </label>

                  <label
                    :class="[
                      'radio-choice',
                      settings && settings.tracking_type === 'Product Tag'
                        ? 'active'
                        : '',
                    ]"
                    @click="chooseTracking('Product Tag')"
                  >Product Tag
                    <input
                      id="tracking-product-tag"
                      class="hidden"
                      type="radio"
                      name="tracking"
                      value="product-tag"
                    />
                  </label>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Product Tag Prefix
                    <span
                      data-tooltip
                      tabindex="1"
                      title="The product tag to look up for vendor association will use whatever is after the prefix chosen on the tag. For example: vendor_John Doe will appear as John Doe."
                    ><i class="fas fa-question-circle"></i
                    ></span>
                  </label>
                </div>

                <div class="cell auto">
                  <input
                    id="vendor_tag"
                    class="medium-input"
                    name="product-tag-prefix"
                    type="text"
                    :value="this.$store.state.metas.vendor_product_tag_prefix !== undefined ? this.$store.state.metas.vendor_product_tag_prefix
                        .meta_value : ''"
                    placeholder="vendor_"
                  />
                </div>
              </div>
            </div>
            <hr/>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Calculation Type
                    <span
                      data-tooltip
                      tabindex="1"
                      title="If flat rate is chosen then the commission will use
                      the cost per item field in shopify."
                    ><i class="fas fa-question-circle"></i
                    ></span>
                  </label>
                </div>

                <div class="cell auto">
                  <label
                    :class="[
                      'radio-choice',
                      settings && !settings.use_cost_per_item ? 'active' : '',
                    ]"
                    @click="chooseCalculation('percentage')"
                  >Percentage
                    <input
                      id="calculation-percentage"
                      class="hidden"
                      type="radio"
                      name="calculation"
                      value="percentage"
                    />
                  </label>

                  <label
                    :class="[
                      'radio-choice',
                      settings && settings.use_cost_per_item ? 'active' : '',
                    ]"
                    @click="chooseCalculation('flat_rate')"
                  >Flat Rate
                    <input
                      id="calculation-flat-rate"
                      class="hidden"
                      type="radio"
                      name="calculation"
                      value="flat-rate"
                    />
                  </label>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Global Commission
                    <span
                      data-tooltip
                      tabindex="1"
                      title="The global commission percentage will be used if no other settings are set such as vendor percentage, product type commissions, or not using flat rate. Example: 10%"
                    ><i class="fas fa-question-circle"></i
                    ></span>
                  </label>
                </div>

                <div class="cell auto">
                  <div class="grid-x align-middle">
                    <div class="cell shrink">
                      <input
                        id="global-commission"
                        class="short-input"
                        name="global-comission"
                        type="text"
                        v-bind:placeholder="30"
                        v-bind:value="this.settings.global_commission"
                      />
                    </div>
                    <div class="cell shrink">
                      <div style="padding-left: 5px;">%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label>Discount Responsibility
                    <span data-tooltip title="The party responsible for any applied product discounts">
                    <i class="fas fa-question-circle"></i></span></label>
                </div>

                <div class="cell auto">
                  <label :class="[discount === 'vendor' ? 'active' : '', 'radio-choice']"
                         for="discount-vendor" @click="changeDiscount('vendor')">Vendor
                    <input id="discount-vendor" class="hidden" type="radio"
                           name="discount" value="vendor"
                           :checked="discount === 'vendor' ? 'checked' : ''">
                  </label>

                  <label :class="[discount === 'store' ? 'active' : '', 'radio-choice']"
                         for="discount-store" @click="changeDiscount('store')">Store
                    <input id="discount-store" class="hidden" type="radio"
                           name="discount-store" value="store"
                           :checked="discount === 'store' ? 'checked' : ''">
                  </label>

                  <label :class="[discount === 'equal' ? 'active' : '', 'radio-choice']"
                         for="discount-equal" @click="changeDiscount('equal')">Equal
                    <input id="discount-equal" class="hidden" type="radio"
                           name="discount-equal" value="equal"
                           :checked="discount === 'equal' ? 'checked' : ''">
                  </label>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x align-middle">
                <div class="cell large-4">
                  <label>Discount Reduction before commission calculation
                    <span data-tooltip title="Enable this if you want the discount reduction to happen before commission is calculated. This is most useful when using a percentage commission.">
                    <i class="fas fa-question-circle"></i></span>
                  </label>
                </div>

                <div class="cell auto">
                  <checkbox @check="enableDiscountPre"
                            :active="metas.consignment_discount_pre_percentage ? metas.consignment_discount_pre_percentage.meta_value : false"></checkbox>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x align-middle">
                <div class="cell large-4">
                  <label>Calculate All Vendors by Profit
                    <span data-tooltip title="If using a percentage based commission this will take the rate by the sale_price minus the cost_per_item for all vendor commissions
                     caluclations. You can turn this on per vendor from the vendor profile page.">
                    <i class="fas fa-question-circle"></i></span>
                  </label>
                </div>

                <div class="cell auto">
                  <checkbox @check="enableCalculateByProfit"
                            :active="metas.consignment_calculate_by_profit ? metas.consignment_calculate_by_profit.meta_value : false"></checkbox>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Date to Start Tracking Commissions
                    <span
                      data-tooltip
                      tabindex="1"
                      title="Commissions for orders before this date will not display or calculate on the vendor."
                    ><i class="fas fa-question-circle"></i
                    ></span>
                  </label>
                </div>

                <div class="cell auto">
                  <datepicker :id="'end-date'" class="medium-input"
                              :format="dateFormat"
                              :clear-button="true"
                              :placeholder="'Dec 31, 2099'"
                              :open-date="new Date(commissionDate)"
                              :value="commissionDate"
                              @cleared="commissionDateSelected"
                              @selected="commissionDateSelected"></datepicker>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="grid-x grid-padding-x">
                <div class="cell large-4">
                  <label
                  >Ignore Order Tags
                    <span
                      data-tooltip
                      tabindex="1"
                      title="Orders that contain any of these tags will not award commission."
                    ><i class="fas fa-question-circle"></i
                    ></span>
                  </label>
                </div>

                <div class="cell auto">
                  <input
                    id="order-tags"
                    class="medium-input"
                    name="order-tags"
                    type="text"
                    :value="this.order_tags !== undefined ? this.order_tags : ''"
                    placeholder="influencer,affiliate..."
                  />

                  <p><small>Comma seperated list.</small></p>
                </div>
              </div>
            </div>
          </div>

          <div class="text-success-color text-right" v-if="success">
            Settings have been saved.
          </div>

          <div class="text-alert-color text-right" v-if="error">
            There was an error saving. Please try again later.
          </div>

          <div class="panel__footer text-right">
            <button @click="save">Save</button>
          </div>
        </div>
      </div>
    </div>

    <productTypes></productTypes>
  </div>
</template>

<script>
import client from '@/mixins/client'
import productTypes from '@/pages/settings/productTypes'
import Commissions from '../vendors/sections/commissions'
import checkbox from '@/globals/checkbox'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'settingsCommissions',
  mixins: [client],
  components: {
    Commissions,
    checkbox,
    productTypes,
    Datepicker
  },
  data: function () {
    return {
      commissionsSaving: false,
      success: false,
      error: false,
      commissionDate: '',
      discount: '',
      order_tags: '',
      commission: []
    }
  },
  methods: {
    changeDiscount (choice) {
      this.discount = choice
    },
    dateFormat (date) {
      return moment(date).format('MMM D, YYYY')
    },
    commissionDateSelected (date) {
      this.commissionDate = date
    },
    enableCalculateByProfit () {
      this.metas.consignment_calculate_by_profit.meta_value = !this.metas.consignment_calculate_by_profit.meta_value
    },
    enableDiscountPre () {
      this.metas.consignment_discount_pre_percentage.meta_value = !this.metas.consignment_discount_pre_percentage.meta_value
    },
    async saveCommissions () {
      let commission = document
        .getElementById('global-commission')
        .value.trim()
      let vendorTag = document.getElementById('vendor_tag').value.trim()
      let orderTags = document.getElementById('order-tags').value.trim()

      this.order_tags = orderTags

      // let date = document.getElementById('date_picker').value

      if (commission === '') {
        commission = this.settings.global_commission
      }

      let updateCommissions = false

      if (this.$store.state.settings.global_commission !== parseFloat(commission) || this.discount !== this.appSettings.discount_share) {
        updateCommissions = true
      }

      this.$store.state.settings.global_commission = commission

      this.$store.state.metas.vendor_product_tag_prefix.meta_value = vendorTag

      await this.$store.dispatch(
        'updateMeta',
        this.metas.vendor_product_tag_prefix
      )

      await this.$store.dispatch(
        'updateMeta',
        this.metas.consignment_discount_pre_percentage
      )

      await this.$store.dispatch(
        'updateMeta',
        this.metas.consignment_calculate_by_profit
      )

      if (this.commissionDate !== undefined && this.commissionDate !== null && this.commissionDate !== '') {
        await this.$store.dispatch(
          'updateAppSettings', {
            commission_start_date: moment(this.commissionDate).format('YYYY-MM-DDT00:00:00')
          }
        )
      } else {
        await this.$store.dispatch(
          'updateAppSettings', {
            commission_start_date: null
          }
        )
      }

      await this.$store.dispatch(
        'updateAppSettings', {
          discount_share: this.discount
        }
      )

      await this.$store.dispatch(
        'updateAppSettings', {
          ignore_order_tags: this.order_tags
        }
      )

      await this.request('put', '/settings/settings/' + this.$store.state.settings.id + '/retrieve-update/', {
        tracking_type: this.settings.tracking_type,
        global_commission: commission,
        use_cost_per_item: this.settings.use_cost_per_item
      })

      if (updateCommissions) {
        await this.request('get', '/orders/calculate-commissions/').then(response => {

        })
      }

      // await this.request('get', '/orders/calculate-commissions/').then(response => {
      //
      // })

      this.success = true
      this.commissionsSaving = false
    },
    save () {
      this.commissionsSaving = true
      this.saveCommissions()
    },
    chooseTracking (tracking) {
      this.settings.tracking_type = tracking
    },
    chooseCalculation (calcType) {
      if (calcType === 'flat_rate') {
        this.settings.use_cost_per_item = true
      }
      if (calcType === 'percentage') {
        this.settings.use_cost_per_item = false
      }
    }
  },
  computed: {
    appSettings () {
      return this.$store.state.appSettings
    },
    settings () {
      return this.$store.state.settings
    },
    metas () {
      return this.$store.state.metas
    }
  },
  created () {
    this.commissionDate = this.appSettings.commission_start_date
    this.discount = this.appSettings.discount_share
    this.order_tags = this.appSettings.ignore_order_tags
  }
}
</script>

<style lang="scss">
@import "../../styles/variables";
@import "../../styles/mixins";
</style>



// WEBPACK FOOTER //
// src/pages/settings/commissions.vue